import React from 'react'
import { useState } from 'react'
import Modal from '../../controls/Modal'
import LodingButton from '../../controls/LodingButton'
import { useFormik } from 'formik'
import Input from '../../controls/Input'
import * as yup from 'yup'
import { FaNotesMedical } from "react-icons/fa";
import { MdBarChart } from "react-icons/md";

const schema = yup.object().shape({
    note: yup.string().required("Note is required."),
    priority: yup.string().required("Priority is required"),
  })



export default function AddFastNoteModal({ isOpen, setIsOpen, AddFastNote, loding }) {

    const { values, handleBlur, handleChange, handleSubmit, errors, touched, isValid, setValues } = useFormik({
        initialValues: {
            note: "",
            priority: "0",
        },
        validationSchema: schema,
        onSubmit(val) {
            AddFastNote(val, setValues)
        }
    })

    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={"Add Fast Note"}>
            <form onSubmit={handleSubmit}>
                <div class="p-6 space-y-6">
                    <div class="grid grid-cols gap-6">
                        <div class="col-span-12">
                            <label for="note" class="block mb-2 text-sm font-medium text-gray-900">Note</label>
                            <Input placeholder="Note"
                                id="note"
                                Icon={<FaNotesMedical className='text-orange-300 h-4 w-4'/>}
                                value={values.note}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.note && touched.note}
                            />
                            {errors.note && touched.note && <p className='text-red-600 text-xs'>{errors.note}</p>}
                        </div>
                       
                        <div class="col-span-12 sm:col-span-6">
                            <label for="priority" class="block mb-2 text-sm font-medium text-gray-900 ">Priority</label>
                            <Input placeholder="Priority"
                                id="priority"
                                type="number"
                                Icon={<MdBarChart className='text-green-300 h-5 w-5'/>}
                                value={values.priority}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.priority && touched.priority}
                            />
                            {errors.priority && touched.priority && <p className='text-red-600 text-xs'>{errors.priority}</p>}
                        </div>

                    </div>
                </div>
                <div class="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b ">
                    {!loding ?
                        <button type="submit" className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid}>Save</button>
                        : <LodingButton text="Wait.." />
                    }
                </div>
            </form>

        </Modal>

    )
}
